import { useRef } from "react";
import { useKey } from "../customHooks/useKey";


export default function Navbar({ findMovies,query,setQuery }) {

  const inputRef=useRef(null)  
// use use key insted of effect
    // useEffect(function(){
    //   document.querySelector('.search').focus();
    // },[])

    // useEffect(function(){
    //   function callback(e){
    //     if(document.activeElement===inputRef.current) return;
    //    if(e.code==="Enter"){
    //      inputRef.current.focus();   
    //     setQuery("")
    //    }
    //   }
    //   document.addEventListener("keydown",callback)
      
    //   return ()=> document.removeEventListener("keydown",callback)
    // },[setQuery])

    useKey("Enter",function(){
          if(document.activeElement===inputRef.current) return;
        inputRef.current.focus();   
        setQuery("")
    })
    
  return (
    <header className="flex justify-between items-center bg-primary w-[98%] rounded-md px-5 text-white mx-auto py-2 font-mono ">
      <h1 className="select-none text-2xl">
        <span role="img">🍿</span>usePopcorn
      </h1>
      <div>
        <input
          type="text"
          placeholder="Search movies..."
          className="search border-0 focus:outline-none rounded-md px-2 py-1 w-72  bg-primaryLight"
          onChange={(e) => setQuery(e.target.value)}
          value={query}
          ref={inputRef}
        />
      </div>
      <p>
        Found <strong>{findMovies.length}</strong> result
      </p>
    </header>
  );
}
